import { Database } from '#types';

type CognitoCfg = { userPoolId: string; userPoolClientId: string };

const DB_TO_COGNITO: Record<Database, CognitoCfg> = { 
    [Database.ZIM]: { userPoolId: process.env.REACT_APP_ZIM_USER_POOL_ID!, userPoolClientId: process.env.REACT_APP_ZIM_USER_POOL_CLIENT_ID! }, 
    [Database.SBB]: { userPoolId: process.env.REACT_APP_SBB_USER_POOL_ID!, userPoolClientId: process.env.REACT_APP_SBB_USER_POOL_CLIENT_ID! }, 
    [Database.GD]: { userPoolId: process.env.REACT_APP_GD_USER_POOL_ID!, userPoolClientId: process.env.REACT_APP_GD_USER_POOL_CLIENT_ID! },
};

export const getAmplifyConfig = (db: Database) => ({
    Auth: {
        Cognito: {
            ...DB_TO_COGNITO[db],
            identityPoolId: '',
            loginWith: { email: true },
            signUpVerificationMethod: 'code' as const,
            userAttributes: {
                email: { required: true },
                given_name: { required: false },
                family_name: { required: false },
                picture: { required: false },
            },
            allowGuestAccess: true,
            passwordFormat: {
                minLength: 8,
                requireLowercase: true,
                requireUppercase: true,
                requireNumbers: true,
                requireSpecialCharacters: true,
            },
        },
    },
});